import React from "react";
import { Helmet } from "react-helmet";

export default function Noindex() {
  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
}
